<template>
  <div :class="body_class">
    <div :class="main_class">
      <notifications
        group="store_notifications"
        position="top left"
        width="auto"
        animation-type="css"
        :speed="600"
      />
      <notifications
        group="toast_top_right"
        position="top right"
        width="auto"
        animation-type="css"
        :speed="600"
      />
      <router-view />
    </div>
  </div>
</template>

<script>

export default {
  name: "app",
  computed: {
    body_class() {
      return [
        "app",
        "view",
        "bodhi-vue-app",
        "view--" + this.$route.name,
        this.$route.meta.navigation === false && 'no-nav',
        this.$route.meta.editor === true ? 'view--editor' : 'view--admin',
        this.$store.state.isInsight ? 'insight' : ''
      ]
    },
    main_class() {
      return window.use_partial_vue_integration ? "" : "main"; 
    }
  }
};
</script>

<style lang="scss">
@import "./styles/app";
</style>
